import React, { useEffect, useState } from 'react'
import { config } from '../../CommonUtils/CommonURLS';
import { CommonAxiosGet } from '../../CommonUtils/CommonAxios';
import { ErrorMessage, Field, Form, FormikProvider, useFormik } from 'formik';
import * as bie from "react-bootstrap";
import CommonReactTable from '../../CommonUtils/CommonReactTable';
import { FiCheckCircle, FiXCircle } from "react-icons/fi";

export const NOC_TYPE_MAP = {
    // "Merger of Institutions": "merge_ofinstructions",
    // "Conversion of the Institution": "type_converstions",
    // "Closure of Institution": "closure_of_institutions",
    // "Trust / Society Name Change": "society_name_change",
    // "Programme / Intake Changes": "intake_changes",
    "Shifting of the Institution": "shifting",
    // "Change of Institution Name": "change_of_inst_name",
    "Extension of Permission (EoP)": "eop",
    "Management Change": "management"
};
export default function ApplicationStatusReport() {
    const [status, setStatus] = useState([]);
    const [isFetched, setIsFetched] = useState(false);
    function GetStatus(noctype) {
        if (!noctype) {
            setIsFetched(false);
            return
        }
        setIsFetched(false);
        CommonAxiosGet(`${config.url.FAC_URL}getNocTypeBasedStatusReport?nocType=${noctype}`)
            .then((res) => {
                // const data = res?.data?.scode === "01" ? res?.data?.data || [] : [];
                const data =
                    res?.data?.scode === "01"
                        ? (res?.data?.data || []).map((item) => ({
                            ...item,
                            scrutiny: getScrutinyStatus(item),
                        }))
                        : [];

                setStatus(data);
                setIsFetched(true); // mark API completed
            })
            .catch(() => {
                setStatus([]);
                setIsFetched(true);
            });
    }




    const renderStatus = (value) => {
        const isDone = String(value).toLowerCase() === "done";

        return isDone ? (
            <FiCheckCircle color="#28a745" size={18} title="Done" />
        ) : (
            <FiXCircle color="#dc3545" size={18} title="Not Done" />
        );
    };

    const getDoneCount = (key) => {
        return status?.filter(
            (item) => String(item[key]).toLowerCase() === "done"
        ).length;
    };
    const getYesCount = (key) => {
        return status?.filter(item => item[key] === "Done").length;
    };
    const StatusColumns = [
        {
            id: "slNo",
            header: "Sl.No",
            cell: ({ row }) => row.index + 1,

        },
        {
            id: "coll_code",
            header: "College Code",
            accessorKey: "coll_code",
        },
        {
            id: "inst_name",
            header: "Institute Name",
            accessorKey: "inst_name",
        },
        {
            id: "ub_name",
            header: "University Name",
            accessorKey: "ub_name",
        },
        {
            id: "noc_type",
            header: "NOC Type",
            accessorKey: "noc_type",
        },
        {
            id: "inst_address",
            header: "Institute Address",
            accessorKey: "inst_address",
            Footer: "Total",

        },
        {
            id: "college_done",
            header: "College Done",
            accessorKey: "college_done",
            cell: ({ getValue }) => renderStatus(getValue()),
            Footer: () => getYesCount("college_done"),
        },


        // {
        //     id: "scrutiny",
        //     header: "Scrutiny",
        //     accessorKey: "scrutiny",
        //     cell: ({ getValue }) => renderStatus(getValue()),

        // },
        {
            id: "scrutiny",
            header: "Scrutiny",

            cell: ({ row }) =>
                renderStatus(getScrutinyStatus(row.original)),

            Footer: () =>
                status?.filter(
                    (item) =>
                        String(getScrutinyStatus(item)).toLowerCase() === "done"
                ).length,
        },
        {
            id: "jd_approved",
            header: "JD Approved",
            accessorKey: "jd_approved",
            cell: ({ getValue }) => renderStatus(getValue()),
            Footer: () => getYesCount("jd_approved"),

        },
        {
            id: "section_approved",
            header: "Section Forwarded",
            accessorKey: "section_approved",
            cell: ({ getValue }) => renderStatus(getValue()),
            Footer: () => getYesCount("section_approved"),

        },
        {
            id: "final_status_by_jd",
            header: "Final Status By JD",
            accessorKey: "final_status_by_jd",
            cell: ({ getValue }) => renderStatus(getValue()),
            Footer: () => getYesCount("final_status_by_jd"),
        },
        {
            id: "digi_sign_done",
            header: "Digital Sign Done",
            accessorKey: "digi_sign_done",
            cell: ({ getValue }) => renderStatus(getValue()),
            Footer: () => getYesCount("digi_sign_done"),
        },
    ];
    const InstitutionFormik = useFormik({
        initialValues: {
            nocType: "",

        },
        // validationSchema,
        enableReinitialize: true,
        onSubmit: (val) => {
            console.log("val", val)
        },
    });

    const getScrutinyStatus = (item) => {
        if (item.noc_type === "management") return item.management_scrutiny;
        if (item.noc_type === "eop") return item.eop_scrutiny;
        if (item.noc_type === "shifting") return item.shifting_scrutiny;
        return "Not Done";
    };



    return (


        <div className="faculty-form-wrapper">
            <div className="faculty-card">

                <h5 className="mb-3 innerheader-new">
                    <span>Total Application Status Report</span>
                </h5>

                <FormikProvider value={InstitutionFormik}>
                    <Form className="form_adjust" onSubmit={InstitutionFormik.handleSubmit} onChange={InstitutionFormik.handleChange}>
                        <bie.Row>
                            <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-2">
                                <label>Select NOC Type</label>
                                <Field
                                    as="select"
                                    name="nocType"
                                    className="form-control"
                                    onChange={(e) => {
                                        InstitutionFormik.handleChange(e);
                                        GetStatus(e.target.value);
                                    }}>
                                    <option value="">--Select--</option>

                                    {Object?.entries(NOC_TYPE_MAP)?.map(([label, value]) => (
                                        <option key={value} value={value}>
                                            {label}
                                        </option>
                                    ))}


                                </Field>


                                <ErrorMessage name="nocType" component="div" className="text-danger" />
                            </bie.Col>
                        </bie.Row>


                        {!isFetched ? null : status.length > 0 ? (
                            <div className="pvp-root">
                                <CommonReactTable
                                    data={status}
                                    columns={StatusColumns}
                                    filename="NOC STATUS REPORT"
                                    headerName="NOC STATUS REPORT"
                                    showFooter={true}
                                    showPagination={false}
                                    showExcel={true}
                                    showPrint={true}
                                    excelFileName="NOC Status Report"
                                />
                            </div>
                        ) : (
                            <center className="text-danger mt-4 h5">
                                ** No Data Found **
                            </center>
                        )}
                    </Form>
                </FormikProvider>
            </div>
        </div >

    )
}
